import { render, staticRenderFns } from "./VerificaAssinatura.vue?vue&type=template&id=1858cc46"
import script from "./VerificaAssinatura.vue?vue&type=script&lang=js"
export * from "./VerificaAssinatura.vue?vue&type=script&lang=js"
import style0 from "./VerificaAssinatura.vue?vue&type=style&index=0&id=1858cc46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports